import React, { useState, useEffect } from 'react';
import { NavLink } from 'react-router-dom';
import './Header.css';

function Header() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 20);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const handleNavClick = () => {
    setIsMobileMenuOpen(false);
    // Scroll to top when navigating
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  return (
    <header className={`header ${isScrolled ? 'scrolled' : ''}`}>
      <div className="header-container">
        <NavLink to="/" className="logo" onClick={handleNavClick}>
          <img src={`${process.env.PUBLIC_URL}/pharmacare-logo.png`} alt="Pharmacare Logo" className="logo-image" />
          <span className="logo-text">PHARMACARE PHARMACIES</span>
        </NavLink>
        
        <button 
          className="mobile-menu-toggle"
          onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
          aria-label="Toggle menu"
        >
          <span></span>
          <span></span>
          <span></span>
        </button>

        <nav className={`nav ${isMobileMenuOpen ? 'mobile-open' : ''}`}>
          <NavLink 
            to="/"
            onClick={handleNavClick}
            className={({ isActive }) => isActive ? 'active' : ''}
          >
            Home
          </NavLink>
          <NavLink 
            to="/about"
            onClick={handleNavClick}
            className={({ isActive }) => isActive ? 'active' : ''}
          >
            About
          </NavLink>
          <NavLink 
            to="/branches"
            onClick={handleNavClick}
            className={({ isActive }) => isActive ? 'active' : ''}
          >
            Branches
          </NavLink>
          <NavLink 
            to="/products"
            onClick={handleNavClick}
            className={({ isActive }) => isActive ? 'active' : ''}
          >
            Products
          </NavLink>
          <NavLink 
            to="/delivery"
            onClick={handleNavClick}
            className={({ isActive }) => isActive ? 'active' : ''}
          >
            Delivery
          </NavLink>
        </nav>
      </div>
    </header>
  );
}

export default Header;
